/**
 * Determines if the domain of the site is for internal users or employees.
 * 
 * @returns { boolean }
 */
function isInternalDomain() {
    return ( window.location.origin || '' ).includes( 'internal' );
}

/**
 * Whether or not the site is for internal users/customers.
 */
export const IS_INTERNAL_SITE = isInternalDomain();
